import React from "react";
import "./index.css";
import Preview from "./Preview/Preview";

export default function QuizVideoDetail(props) {
    return <Preview id={props.match.params.id} />;
}
